export default Object.freeze({
  EXPOSURE_ANALYTICS: 'EXPOSURE_ANALYTICS',
  INSIGHT_VM_AGENT: 'INSIGHT_VM_AGENT',
  NONE: '',
});
